import type { ReactNode } from 'react';

import { cn } from '~/utils/cn';

import type { CostEstimateStatus } from '../types/cost-estimate.types';
import { STATUS_CHIP_CLASS, STATUS_CHIP_ICON } from '../utils/status-chip';

/** Rounded status pill (icon + label) coloured per gate status — shared by the card, details
 *  header and History. */
export function CostStatusChip({
  status,
  className,
  children,
  testId = 'cost-status-chip',
}: {
  status: CostEstimateStatus;
  className?: string;
  children: ReactNode;
  /** `data-testid` for the pill. */
  testId?: string;
}) {
  const Icon = STATUS_CHIP_ICON[status] as
    | (typeof STATUS_CHIP_ICON)[CostEstimateStatus]
    | undefined;
  return (
    <span
      data-testid={testId}
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium',
        STATUS_CHIP_CLASS[status],
        className,
      )}
    >
      {Icon ? <Icon className="h-3 w-3 shrink-0" aria-hidden="true" /> : null}
      {children}
    </span>
  );
}
